export default __webpack_public_path__ + "static/media/icon_evn_setting.5bcd240f.svg";